export default "__VITE_PUBLIC_ASSET__a9c7c673__"